<template>
    <v-container fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="orange darken-3">
                        <v-toolbar-title>Register</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-text-field prepend-icon="person"
                                          name="name"
                                          label="Name"
                                          v-model="name"
                                          :rules="nameRules"
                                          required>
                            </v-text-field>
                            <v-text-field prepend-icon="person"
                                          name="email"
                                          label="Email"
                                          type="email"
                                          v-model="email"
                                          :rules="emailRules"
                                          data-cy="joinEmailField"
                                          required>
                            </v-text-field>
                            <v-text-field prepend-icon="lock"
                                          name="password"
                                          label="Password"
                                          type="password"
                                          required
                                          v-model="password"
                                          :rules="passwordRules"
                                          data-cy="joinPasswordField">
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            :disabled="!valid"
                            @click="submit"
                            data-cy="joinSubmitBtn"
                            >Register</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'Join',
    data() {
        return {
            valid: false,
            name: '',
            email: '',
            password: '',
            nameRules: [
                v => !!v || 'Name is required',
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v =>
                    v.length >= 6 ||
                    'Password must be greater than 6 characters'
            ]
        };
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('userJoin', {
                    name: this.name,
                    email: this.email,
                    password: this.password
                });
            }
        }
    }
};
</script>

<style scoped></style>
